import { i18n } from '@/i18n'
import isFQDN from 'validator/lib/isFQDN'

export default Validator => {
  Validator.registerAsync('domainAvailable', async function (domain, attribute, req, passes) {
    let onSuccess = () => passes()
    let onError = () => passes(false, i18n.t('isTaken', { x: i18n.t('domain') }))

    if (!isFQDN(domain || '')) return onSuccess()

    let [id] = attribute.split(',')

    const url = new URL(`${window.location.origin}/api/dns/available`)
    url.searchParams.append('domain', domain)
    if (id) url.searchParams.append('id', id)

    return fetch(url.toString())
      .then(res => res.json())
      .then(({ status }) => {
        if (!status) return onError()
        return onSuccess()
      })
      .catch(onError)
  })
}
